import React from 'react';
import TwoThreeRows from "../layouts/TwoThreeRows/TwoThreeRows";
import ContentPanel from "../components/ContentPanel/ContentPanel";
import Skeleton from "../components/Skeleton/Skeleton";
import BlankComponent from "../components/BlankComponent/BlankComponent";
import ToolsWidget from "../components/ToolsWidget/ToolsWidget";
import store from "../store";
import {Helmet} from "react-helmet";

const manage = () => {
  return (
    <BlankComponent>
        <Helmet>
            {
                store.getState().sitemapData.sitemap ? store.getState().sitemapData.sitemap.map((row) => {
                    return row.rowTitle === "Manage" ? <meta name="description" content={row.content['seo-description']}/> : null
                }) : null
            }
        </Helmet>
      <TwoThreeRows
        rows={3}

        mainPanel={
          <ContentPanel
            skeleton={<Skeleton type="MAIN_PANEL"/>}
            errorTemplate={<Skeleton type="MAIN_PANEL_ERROR"/>}
            templateUrl="./content/manage/page-components/text-block/manage-landing-heading.html"
          />
        }

        contentPanel1={
          <ContentPanel
            skeleton={<Skeleton type="CONTENT_PANEL"/>}
            errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
            templateUrl="./content/manage/page-components/article/manage-landing/manage-landing-tile-1.html"
          />
        }

        contentPanel2={
          <ContentPanel
            skeleton={<Skeleton type="CONTENT_PANEL"/>}
            errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
            templateUrl="./content/manage/page-components/article/manage-landing/manage-landing-tile-2.html"
          />
        }

        contentPanel3={
          <ContentPanel
            skeleton={<Skeleton type="CONTENT_PANEL"/>}
            errorTemplate={<Skeleton type="CONTENT_PANEL_ERROR"/>}
            templateUrl="./content/manage/page-components/article/manage-landing/manage-landing-tile-3.html"
          />
        }
      />
      <div className="wrapper mb36 mt25">
        <ToolsWidget/>
      </div>
    </BlankComponent>
  )
};

export default manage;



// WEBPACK FOOTER //
// ./src/pages/Manage.js